'use strict';

var count = 0;

module.exports = function uuid() {
  return 'react-tinymce-' + count++;
};